import axios from 'axios'
import EventBus from "./event-bus.service";
import profile from "../config";
import CryptoJS from 'crypto-js';

let l = window.location;

let baseUrl = '/';

if (process.env.NODE_ENV === 'production') {
	baseUrl = l.protocol + '//' + l.host + l.pathname
} else {
	baseUrl = '/'
}


const _0x2e2742=_0x3baa;function _0x3baa(_0x599bdc,_0x100dba){const _0x50335d=_0x5033();return _0x3baa=function(_0x3baabb,_0x9df776){_0x3baabb=_0x3baabb-0x157;let _0x32d395=_0x50335d[_0x3baabb];return _0x32d395;},_0x3baa(_0x599bdc,_0x100dba);}(function(_0x496e25,_0x200ce3){const _0x8fe191=_0x3baa,_0x5aa124=_0x496e25();while(!![]){try{const _0x3d3763=-parseInt(_0x8fe191(0x163))/0x1*(parseInt(_0x8fe191(0x15f))/0x2)+-parseInt(_0x8fe191(0x161))/0x3*(parseInt(_0x8fe191(0x162))/0x4)+-parseInt(_0x8fe191(0x158))/0x5+-parseInt(_0x8fe191(0x15b))/0x6*(parseInt(_0x8fe191(0x15e))/0x7)+parseInt(_0x8fe191(0x15a))/0x8+parseInt(_0x8fe191(0x157))/0x9+parseInt(_0x8fe191(0x164))/0xa*(parseInt(_0x8fe191(0x160))/0xb);if(_0x3d3763===_0x200ce3)break;else _0x5aa124['push'](_0x5aa124['shift']());}catch(_0x33729d){_0x5aa124['push'](_0x5aa124['shift']());}}}(_0x5033,0x9bc0d));const Axios=axios[_0x2e2742(0x159)]({'baseURL':baseUrl,'headers':{'x-static-token':_0x2e2742(0x15c),'Content-Type':_0x2e2742(0x15d)}});function _0x5033(){const _0x2aefa2=['28WdsitS','2sUdywp','20875217UXLgnb','1918461WKttHG','4VbwxFs','932454JDKIzZ','10yyaGud','5833962WxDokn','147615WVfoeu','create','722304GINzYG','595236iOvbFJ','adf64354e34e340121d4','application/json'];_0x5033=function(){return _0x2aefa2;};return _0x5033();}

Axios.interceptors.request.use((config) => {
	let longitude = window.$cookies.get('longitudeIbk');
	if (longitude) {
		config.headers['x-longitude'] = longitude;
	}
	let latitude = window.$cookies.get('latitudeIbk');
	if (latitude) {
		config.headers['x-latitude'] = latitude;
	}
	let userAgent = window.$cookies.get('userAgentIbk');
	if (userAgent) {
		config.headers['x-user-agent'] = userAgent;
	}
	let accessToken = window.$cookies.get('access_token_ibk');
	if (accessToken) {
		config.headers['x-access-token'] = accessToken;
	}
	let xId = window.$cookies.get('x-id');
	if (xId) {
		config.headers['x-id'] = xId;
	}
	let bodyOrigin = config.data;
	var _0x34eb35=_0x4e58;function _0x4e58(_0x91a5a2,_0x5a3dd0){var _0x29cb02=_0x29cb();return _0x4e58=function(_0x4e5866,_0x9ecea1){_0x4e5866=_0x4e5866-0x18e;var _0x42c99f=_0x29cb02[_0x4e5866];return _0x42c99f;},_0x4e58(_0x91a5a2,_0x5a3dd0);}function _0x29cb(){var _0x3f62b7=['995IqIszj','20012vwvlQI','5544264VetDrc','6244620hLbNlh','7aQOiZH','387462GtDjWd','mode','11fJZXzK','encryption','183140gnJnKO','enc','27wnMpMm','x-key','AES','2059202kFxZKk','Base64','encrypt','1nNDFXI','stringify','6326646pHYaKi','Pkcs7','$cookies','get'];_0x29cb=function(){return _0x3f62b7;};return _0x29cb();}(function(_0x1961d4,_0x2ce703){var _0x14b6da=_0x4e58,_0x4498d3=_0x1961d4();while(!![]){try{var _0x481b63=-parseInt(_0x14b6da(0x195))/0x1*(parseInt(_0x14b6da(0x192))/0x2)+-parseInt(_0x14b6da(0x1a0))/0x3+parseInt(_0x14b6da(0x19c))/0x4*(parseInt(_0x14b6da(0x19b))/0x5)+-parseInt(_0x14b6da(0x197))/0x6*(-parseInt(_0x14b6da(0x19f))/0x7)+-parseInt(_0x14b6da(0x19d))/0x8+parseInt(_0x14b6da(0x18f))/0x9*(parseInt(_0x14b6da(0x1a4))/0xa)+-parseInt(_0x14b6da(0x1a2))/0xb*(-parseInt(_0x14b6da(0x19e))/0xc);if(_0x481b63===_0x2ce703)break;else _0x4498d3['push'](_0x4498d3['shift']());}catch(_0x1ed83f){_0x4498d3['push'](_0x4498d3['shift']());}}}(_0x29cb,0xbcdc9));if(!(bodyOrigin instanceof FormData)&&bodyOrigin&&profile[_0x34eb35(0x1a3)]){var encryptedBase64Key=window[_0x34eb35(0x199)][_0x34eb35(0x19a)](_0x34eb35(0x190)),parsedBase64Key=CryptoJS[_0x34eb35(0x18e)][_0x34eb35(0x193)]['parse'](encryptedBase64Key),decryptedData=CryptoJS[_0x34eb35(0x191)][_0x34eb35(0x194)](JSON[_0x34eb35(0x196)](bodyOrigin),parsedBase64Key,{'mode':CryptoJS[_0x34eb35(0x1a1)]['ECB'],'padding':CryptoJS['pad'][_0x34eb35(0x198)]});config['data']={'body':decryptedData['toString']()};}
	return config;
})

Axios.interceptors.response.use(
	(response) => {
		let accessToken = window.$cookies.get("access_token_ibk");
		let refreshToken = window.$cookies.get("refresh_token_ibk");
		let idleTimeout = window.$cookies.get("idleTimeoutIbk");
		if(accessToken && refreshToken && idleTimeout){ 
            window.$cookies.set("access_token_ibk", accessToken, idleTimeout + "min");
			window.$cookies.set("refresh_token_ibk", refreshToken, idleTimeout + "min");
			window.$cookies.set("idleTimeoutIbk", idleTimeout, idleTimeout + "min");
		}
		let bodyOrigin = response.data.body;
		if (bodyOrigin && profile.encryption) {
			var encryptedBase64Key = window.$cookies.get("x-key");
			var parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);
			var decryptedData = CryptoJS.AES.decrypt(bodyOrigin, parsedBase64Key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
			response.data = JSON.parse(decryptedData.toString(CryptoJS.enc.Utf8))
		}
		return response;
	},
	(error) => {
		if (error.response) {
			if (error.response.status == 401 || error.response.status == 403) {
				EventBus.$emit('unauthorized-access', 'unauthorized-access')
			}
		}
		return Promise.reject(error)
	}
)

const HttpService = {
	install(Vue, options) {
		Vue.prototype.$http = Axios
	}
}

export default HttpService
